import type { BookingRefundHistoryScope } from '../hooks/bookings/useBookingRefundHistory';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  fetchAvailableBookingEvents,
  fetchBookingEventDetail,
  fetchBookingSeriesOccurrences,
  fetchMarketplaceBookingEvents,
  fetchSessionBalance,
  fetchMyBookings,
  resolveBookingVipLink,
} from '../api/bookings.api';

export const bookingsQueryKeys = createQueryKeys('bookings', {
  refundHistory: (scope: BookingRefundHistoryScope) => ({
    queryKey: [
      scope.userId,
      scope.tenantId,
      scope.organizationId,
      scope.perspective,
    ],
  }),
  fetchAvailableBookingEvents: (args: {
    organizationId: string;
    vipToken?: string;
    from?: string;
    to?: string;
  }) => ({
    queryFn: () => fetchAvailableBookingEvents(args),
    queryKey: [args.organizationId, args.from, args.to, args.vipToken],
  }),
  resolveBookingVipLink: (args: { token: string }) => ({
    queryFn: () => resolveBookingVipLink(args),
    queryKey: [args.token],
  }),
  fetchBookingEventDetail: (args: {
    bookingEventId: string;
    organizationId: string;
  }) => ({
    queryFn: () => fetchBookingEventDetail(args),
    queryKey: [args.organizationId, args.bookingEventId],
  }),
  fetchBookingSeriesOccurrences: (args: {
    organizationId: string;
    seriesId: string;
    from?: string;
    limit?: number;
  }) => ({
    queryFn: () => fetchBookingSeriesOccurrences(args),
    queryKey: [args.organizationId, args.seriesId, args.from, args.limit],
  }),
  fetchMarketplaceBookingEvents: (args: {
    limit?: number;
    offset?: number;
  }) => ({
    queryFn: () => fetchMarketplaceBookingEvents(args),
    queryKey: [args.limit, args.offset],
  }),
  fetchMyBookings: (args: {
    clientUserId?: string;
    includeCancelled?: boolean;
    organizationId: string;
    from?: string;
    to?: string;
    timeZone?: string;
  }) => ({
    queryFn: () => fetchMyBookings(args),
    queryKey: [
      args.organizationId,
      args.from,
      args.to,
      args.includeCancelled,
      args.clientUserId,
      args.timeZone,
    ],
  }),
  fetchSessionBalance: (args: { organizationId: string }) => ({
    queryFn: () => fetchSessionBalance(args),
    queryKey: [args.organizationId],
  }),
});
